"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitiateCheckoutCommand = void 0;
class InitiateCheckoutCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { contents, customer, value, total_quantity } = this.input;
        const { cdp: cdpTracking } = config;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        cdpTracking?.web_event.track('product', 'checkout_cart', {
            items: contents?.map((content) => ({
                id: content?.content_data?.sku ?? 'no-id-view-content',
                name: content?.content_data?.name ?? 'no-name-view-content',
                type: 'product',
            })) ?? [],
            ...(customer && {
                dims: {
                    customers: {
                        customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                        name: customer?.name ?? 'no-customer-name',
                        email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                        phone: customer?.phone ?? 'no-customer-phone',
                        cdp_source: 'Production',
                    },
                },
            }),
            extra: {
                cart_subtotal: value,
                cart_item_count: total_quantity,
            },
        });
        return Promise.resolve();
    }
}
exports.InitiateCheckoutCommand = InitiateCheckoutCommand;
